// Demo mode - prevent all Firestore writes with friendly messages
(function() {
  if (!window.isDemoMode) return;

  console.log('Demo mode: Blocking all Firestore writes');

  // Show warning banner on page load
  const showBanner = () => {
    if (document.getElementById('demo-warning-banner')) return;

    const banner = document.createElement('div');
    banner.id = 'demo-warning-banner';
    banner.className = 'alert alert-info alert-dismissible fade show';
    banner.style.cssText = 'margin: 1rem; position: sticky; top: 0; z-index: 1000; border-left: 4px solid #0c5460;';
    banner.innerHTML = `
      <strong>Demo Dashboard - View Only</strong><br>
      This is a read-only demo. Changes you make will not be saved. Refresh the page to reset.
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `;

    const container = document.getElementById('dashboard-container');
    if (container && container.firstChild) {
      container.insertBefore(banner, container.firstChild);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showBanner);
  } else {
    setTimeout(showBanner, 100);
  }

  // Listen for failed save attempts and show friendly message
  const checkForErrors = () => {
    const errorAlerts = document.querySelectorAll('.alert-danger');
    errorAlerts.forEach(alert => {
      if (alert.textContent.includes('Failed to save') || alert.textContent.includes('database')) {
        alert.classList.remove('alert-danger');
        alert.classList.add('alert-info');
        alert.innerHTML = `
          <i class="bi bi-info-circle me-2"></i>
          <strong>Demo Mode</strong> - This change was not saved (read-only demo)
          <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        `;

        // Auto-dismiss after 4 seconds
        setTimeout(() => {
          const closeBtn = alert.querySelector('.btn-close');
          if (closeBtn) closeBtn.click();
        }, 4000);
      }
    });
  };

  // Check for errors periodically
  setInterval(checkForErrors, 500);

  // Also intercept showToast calls
  const originalShowToast = window.showToast;
  window.showToast = function(message, type) {
    // Convert failed saves to friendly info messages
    if (message && (message.includes('Failed to save') || message.includes('database'))) {
      message = 'Demo mode - changes are not saved';
      type = 'info';
    }
    if (originalShowToast) {
      return originalShowToast(message, type);
    }
  };
})();
